import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const GlintsProfile = () => {
  return (
    <>
      <Subtitle>Glints Profile</Subtitle>
      <Paragraph>
        Glints provides all Registered Users with the option of creating a
        personal Glints Profile (“Glints Profile“). A Glints Profile can include
        a resume, employment and educational history, contact details, salary
        expectations, and preferred job classifications and locations.
        Advertisers who are approved by Glints are able to search Glints Profile
        database to find and contact relevant candidates.
      </Paragraph>
      <Paragraph>
        Advertisers who use the invitations to apply for jobs function will only
        receive access to your contact information if you respond directly to
        the job invitation sent to you.
      </Paragraph>
      <Paragraph>
        If you have replied to a job invitation sent by an Advertiser or you
        have applied for jobs directly on the Site using your profile, that
        Advertiser will have access to your up-to-date profile, including your
        contact details (as updated by you from time to time).
      </Paragraph>
      <Paragraph>
        All information provided when creating a Glints Profile (including your
        name, resume, email address, telephone numbers, employment and
        educational history) may be used by Glints for the purpose of improving
        placement opportunities for you or for tailoring specific products to
        you.
      </Paragraph>
      <Paragraph>
        Where you create a Glints Profile on Glints, you consent to your profile
        being viewed and/or accessed by Advertisers using the websites of any
        member of the Glints Group, which may result in the transfer of your
        personal data from Singapore to the other countries in which the other
        members of the Glints Group operate.
      </Paragraph>
      <Paragraph>
        As a Registered User, you can modify your Glints Profile, your resume or
        modify the privacy options in relation to your Glints Profile at any
        time, by going to the Profile area of the Site.
      </Paragraph>
      <Paragraph>
        You may also elect to clear your Glints Profile altogether. Cleared
        Glints Profiles may still however be stored by Glints in testing or
        backup systems for a period of time. Glints reserves the right to
        disable or clear a Glints Profile at any time at its sole discretion.
      </Paragraph>
      <Paragraph>
        Advertisers that place job ads on Glints, and that purchase Glints
        Profiles are asked by Glints to comply with all relevant laws and
        obligations relating to the use and disclosure of personal information.
        The use of your information (personal or otherwise) by these Advertisers
        is not within the control of Glints and we cannot accept responsibility
        for the conduct of these companies.
      </Paragraph>
    </>
  );
};
